/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { Label, Item, Table, Popup, Icon, Button } from 'semantic-ui-react'
import firebase from 'firebase/app'
import get from 'lodash/get'
import map from 'lodash/map'

import utils from '../../../../utils'
import colors from '../../../../assets/colors'
import NeedSupportPopup from '../../../../lib/NeedSupportPopup'

export default class MerchantCell extends React.PureComponent {
  state = {
    visibleKey: null,
    loadingKey: null,
  }

  onResolveSupport = () => {
    const { order } = this.props
    const branchKey = order.restaurant.branch.key

    const updates = {}

    updates[`orders/${order.key}/restaurant_need_support`] = null
    updates[`branch_orders/${branchKey}/${order.key}/restaurant_need_support`] = null
    updates[`orders/${order.key}/restaurant_need_support_at`] = null
    updates[`branch_orders/${branchKey}/${order.key}/restaurant_need_support_at`] = null

    firebase
      .database()
      .ref()
      .update(updates)
  }

  onMerchantNameClick = () => {
    const { readOnly, showMerchantMapWithDrivers } = this.props

    if (!readOnly && showMerchantMapWithDrivers) showMerchantMapWithDrivers()
  }

  onAutoCall = async (tel, key) => {
    try {
      const { order } = this.props
      const orderKey = order.key

      const merchantPhone = tel.replace(/^0/, '+855')

      this.setState({ loadingKey: key })

      const callable = firebase.app().functions('asia-northeast1').httpsCallable('createAutoCall')
      await callable({ orderKey, merchantPhone })

      this.setState({ loadingKey: null, visibleKey: null })
    } catch (error) {
      this.setState({ loadingKey: null, visibleKey: null })
      alert(`Failed to auto call to ${tel}`)
    }
  }

  renderMerchantNeedSupport = () => {
    const { order } = this.props
    const isNeedSupport = order.restaurant_need_support

    if (isNeedSupport)
      return <NeedSupportPopup needSupport={isNeedSupport} onResolve={this.onResolveSupport} />

    return null
  }

  renderOrderNumber = () => {
    const { order } = this.props
    const isCall = order.restaurant.branch.operation_type === 'Call'

    return (
      <Popup
        wide
        on="click"
        hideOnScroll
        position="top center"
        trigger={
          <Icon
            size="large"
            style={{ cursor: 'pointer' }}
            color={isCall ? 'red' : 'green'}
            name={isCall ? 'phone' : 'mobile'}
          />
        }
      >
        <React.Fragment>
          Order Number: <Label>{utils.order.getOrderNumber(order)}</Label>
        </React.Fragment>

        <div style={{ marginTop: 5 }}>
          Order UID: <Label>{order.key}</Label>
        </div>
      </Popup>
    )
  }

  renderAutoCallStatus = tel => {
    const { order } = this.props

    const autoCalls = get(order, 'auto_calls', null)
    const calledPhones = autoCalls && Object.keys(autoCalls).map(phone => utils.helpers.convertToLocalPhoneNumber(phone))
    const isCalledPhone = autoCalls && calledPhones.includes(tel)

    if (autoCalls && isCalledPhone) {
      const globalFormatTel = tel.replace(/^0/, '+855')
      const status = get(autoCalls[globalFormatTel], 'status', '')

      const isCallSuccess = status === 'completed'
      const isCallInit = status === 'queued'

      const iconName = !isCallSuccess ? 'close' : 'check circle'

      return (
        <Icon
          size='small'
          name={isCallInit ? 'volume control phone' : iconName}
          color={isCallSuccess ? 'green' : 'red'}
        />
      )
    }

    return null
  }

  renderPhoneNumber = (numberWithNetwork, callableMerchantTel, phoneType) => {
    const { order } = this.props
    const { loadingKey, visibleKey } = this.state
    const isCall = order.restaurant.branch.operation_type === 'Call'

    const popupKey = `${order.key}-${phoneType}-${callableMerchantTel}`

    return (
      <Popup
        key={callableMerchantTel}
        trigger={
          <div style={{ display: 'flex', marginTop: 5, padding: 0, justifyContent: 'space-between', alignItems: 'center' }} key={callableMerchantTel}>
            <p style={{ fontWeight: 'bold', fontSize: 15, marginBottom: 0, color: 'black' }}>
              {numberWithNetwork}
            </p>
            {this.renderAutoCallStatus(callableMerchantTel)}
          </div>
        }
        on="click"
        hoverable
        hideOnScroll
        open={visibleKey === popupKey}
        onOpen={() => this.setState({ visibleKey: popupKey })}
        onClose={() => this.setState({ visibleKey: null })}
        position="top center"

      >
        <Button.Group vertical size='mini'>
          <Button
            style={{ marginBottom: 5 }}
            onClick={() => this.onAutoCall(callableMerchantTel, popupKey)}
            disabled={isCall}
            loading={loadingKey === popupKey}
          >
            Auto Voice Call
          </Button>

          <Button>
            <a href={utils.helpers.convertToCallableLink(callableMerchantTel)} style={{ color: '#5A5A5A' }}>
              Manual Call
            </a>
          </Button>
        </Button.Group>
      </Popup>
    )
  }

  renderPhoneNumbers = (phoneType, phones) => {
    let displayPhones = []

    if (!phones) {
      displayPhones.push(
        <p style={{ fontWeight: 'bold', fontSize: 15, marginBottom: 0 }} key="no-number">
          No Number
        </p>
      )
    } else {
      const splittedPhones = phones.split(/\s*[,|/]\s*/)

      displayPhones = map(splittedPhones, eachPhone => {
        const phoneNetwork = utils.network.searchNetwork(eachPhone)
        const callableMerchantTel = utils.helpers.convertToLocalPhoneNumber(eachPhone)

        const splitEveryThreeDigitTwice = /^(.{3})(.{3})(.*)$/
        const phoneWithSpace = callableMerchantTel ? callableMerchantTel.replace(splitEveryThreeDigitTwice, "$1 $2 $3") : eachPhone
        const numberWithNetwork = phoneWithSpace ? `${phoneWithSpace} ${phoneNetwork}` : 'N/A'

        return this.renderPhoneNumber(numberWithNetwork, callableMerchantTel, phoneType)
      })
    }

    return (
      <Item style={{ cursor: 'pointer', margin: 0, padding: 0 }}>
        <Item.Content>
          <Item.Meta style={{ fontSize: 14 }}>{phoneType}</Item.Meta>
          <Item.Description style={{ fontWeight: 'bold', fontSize: 15 }}>{displayPhones}</Item.Description>
        </Item.Content>
      </Item>
    )
  }

  render() {
    const { order } = this.props

    const merchantName = order.restaurant.name
    const branchName = order.restaurant.branch.name
    const merchantType = order.restaurant.merchant_type === 'mart' ? 'Mart' : 'F & B'
    const merchantTypeColor = order.restaurant.merchant_type === 'mart' ? 'green' : 'grey'

    const orderPhone = order.restaurant.branch.order_phone || null
    const managerPhone = order.restaurant.branch.manager_phone || null

    return (
      <Table.Cell>
        <Item.Group style={{ margin: 0 }} divided>
          <Item style={{ cursor: 'pointer', margin: 0, padding: 0 }}>
            <Item.Content onClick={this.onMerchantNameClick}>
              <Item.Header style={{ fontSize: 14 }}>{merchantName}</Item.Header>
              <Item.Meta style={{ fontSize: 13 }}>{branchName}</Item.Meta>
            </Item.Content>

            <Item.Extra style={{ display: 'flex', flex: 0, padding: 0, margin: 0 }}>
              {this.renderMerchantNeedSupport()}
              {this.renderOrderNumber()}
            </Item.Extra>
          </Item>

          {this.renderPhoneNumbers('Order Tel: ', orderPhone)}
          {this.renderPhoneNumbers('Manager Tel: ', managerPhone)}

          {order.restaurant.branch.merchant_settlement && (
            <Label style={{ marginTop: 10, backgroundColor: colors.yellow, color: colors.black }}>
              Pay Later
            </Label>
          )}

          <Label style={{ marginTop: 10 }} color={merchantTypeColor}>
            {merchantType}
          </Label>

        </Item.Group>
      </Table.Cell>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/orders/components/OrderListItem/MerchantCell.js